<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    fixed
    temporary
  >
    <v-list
      nav
      dense
    >
      <!-- ログインユーザー表示 -->
      <template v-if="authUserName">
        <div class="my-3">
          <span>こんにちは、{{ authUserName }}さん</span>
        </div>
      </template>
      <!-- 未ログイン時表示 -->
      <template v-else>
        <div class="my-3">
          こんにちは、
          <div class="text-center">
            <!-- ログインボタン -->
            <icon-btn 
              icon="mdi-account"
              text="ログインしてください"
              :large="false"
              @btn-click="loginBtnClick"
            ></icon-btn>
          </div>
        </div>
      </template>
      <v-divider></v-divider>
      
      <!-- 操作メニュー -->
      <v-list-item-group active-class="primary--text text--accent-4">
        <template v-for="(menu, index) in menus">
          <v-list-item 
            v-if="menu.type=='item'" 
            :key="menu.text" 
            @click="menu.action"
          >
            <v-list-item-icon>
              <v-badge
                v-if="menu.badgeCounter"
                :content="menu.badgeCounter"
                :value="menu.badgeCounter"
                color="red lighten-1"
                overlap
              >
                <v-icon>{{ menu.icon }}</v-icon>
              </v-badge>            
              <v-icon v-else>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menu.text }}</v-list-item-title>
          </v-list-item>
          <v-divider 
            v-else-if="menu.type=='devider'" 
            :key="`devider${index}`"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import IconBtn from './IconBtn.vue'

export default {
  name: 'UserNavDrawer',
  components: {
    IconBtn
  },
  props:{
    menus: Array,
    authUserName: String,
  },
  data: () => ({
    drawer: false,
  }),
  methods: {
    open() {
      this.drawer = true
    },
    close() {
      this.drawer = false
    },
    loginBtnClick() {
      this.$emit('login-btn-click')
    }
  },
}
</script>